import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Breadcrumb() {
  const location = useLocation();
  const paths = location.pathname.split('/').filter(Boolean);

  if (location.pathname === '/') return null;

  const categoryMap = Object.fromEntries(categories.map((c) => [c.slug, c.name]));

  return (
    <nav className="max-w-[1400px] mx-auto px-4 md:px-6 pt-20 pb-4" aria-label="面包屑导航">
      <ol className="flex items-center flex-wrap gap-2 text-sm text-foreground-500">
        <li>
          <Link to="/" className="text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer">
            首页
          </Link>
        </li>
        {paths.map((segment, index) => {
          const isLast = index === paths.length - 1;
          const path = `/${paths.slice(0, index + 1).join('/')}`;
          const label = categoryMap[segment] || segment;
          return (
            <li key={path} className="flex items-center gap-2">
              <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
              {isLast ? (
                <span className="text-foreground-900 font-medium">{label}</span>
              ) : (
                <Link
                  to={path}
                  className="text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  {label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}